import { render } from "./OrdersKanbanPage.vue?vue&type=template&id=79ff8c9a&scoped=true"
import script from "./OrdersKanbanPage.vue?vue&type=script&lang=js"
export * from "./OrdersKanbanPage.vue?vue&type=script&lang=js"

import "./OrdersKanbanPage.vue?vue&type=style&index=0&id=79ff8c9a&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79ff8c9a"]])

export default __exports__